const contractTypes = {
    summary_and_overview: 'Summary And Overview',
    terms_and_conditions: 'Terms And Conditions',
    srec_agreement: 'REC Agreement',
    security_addendum: 'Security Addendum',
};

export default contractTypes;